// extracted by mini-css-extract-plugin
module.exports = {"GithubLogo":"GithubLogo_GithubLogo__3TQhV"};